<template>
  <div>
    <a-modal :visible="modalVisible" :closable="false" :width="800" @cancel="closeModal">
      <a-table :width="700" :columns="columns" :data-source="taskList">
        <span slot="taskName" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.taskName">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.taskName }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{
            taskStatus[record.status].label }}</a-tag>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>
import { taskStatus } from '@/utils/dictionary';
export default {
  props: {
    taskList: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      modalVisible: false,
      taskStatus,
      columns: [
        {
          title: '任务id',
          dataIndex: 'taskId',
          width: 100,
          key: 'taskId',
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '任务标题',
          dataIndex: 'taskName',
          width: 300,
          key: 'taskName',
          scopedSlots: { customRender: 'taskName' }
        },
        {
          title: '任务点',
          dataIndex: 'point',
          width: 100,
          key: 'point',
          scopedSlots: { customRender: 'point' }
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.project && record.taskId ? this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.taskId }, params: { project_id: record.project }}).href : '';
      };
    }
  },
  methods: {
    // 获取任务列表
    getTodoList() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    open() {
      this.modalVisible = true;
    }
  }
};
</script>

<style scoped>
    .purple {
      background-color: rgba(128, 50, 150, 0.5);
      color: white;
      border-radius: 6px;
    }

    .orange {
      background-color: orange;
      color: white;
      border-radius: 6px;
    }

    .purple-orange {
      background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
      color: white;
      border-radius: 6px;
    }
</style>

